import { Pipe, PipeTransform } from '@angular/core';
import { NumberCons, StringConst } from 'src/app/constants/const';
import { CommonService } from '../../services/common.service';
import { MaskService } from '../../services/mask.service';

@Pipe({
  name: 'hideCard',
})
export class HideCardPipe implements PipeTransform {
  index = NumberCons.one;
  cardReturn = StringConst.empty;
  cardList: string[] = [];

  constructor(
    private commonService: CommonService,
    private maskService: MaskService
  ) {}

  transform(card: string, args: string): string {
    const haveCard: boolean = this.commonService.validateValidString(card);
    const haveArgs: boolean = this.commonService.validateValidString(args);
    if (this.commonService.validateAndValue([haveCard, haveArgs])) {
      this.cardReturn =
        card.length > 0
          ? this.maskService.maskCardNumber(card, args)
          : StringConst.empty;
      return this.cardReturn;
    }
    return StringConst.empty;
  }
}
